<template>
  <div class="video-wrap">
    <div style="width:500px;height:455px;float: left;margin: 14px;
    margin-top: 0px;" v-for="(item,index) in videoData" :key="index">
      <ezuikit-video :video="{src:item.cameraEzvizUrl,title:item.name,appKey:item.appKey,appSecret:item.appSecret,cameraType:item.cameraType,cameraSerialNumber:item.cameraSerialNumber,channelNo:item.channelNo}"></ezuikit-video>
    </div>
  </div>
</template>
<script>
import api from "@common/api/index.js";
import EzuikitVideo from "@/components/common/EzuikitVideo";
export default {
  name: "videoView",
  // 引用组件
  components: { EzuikitVideo },
  data () {
    return {
      videoData: [],
    };
  },
  // 在实例初始化之后，数据观测(data observer) 和 event/watcher 事件配置之前被调用。
  beforeCreate () { },
  // 实例已经创建完成之后被调用。
  create () { },
  // el 被新创建的 vm.$el 替换，并挂载到实例上去之后调用该钩子。
  mounted () {
    let vm = this;
    vm.$eventBus.$on("changeCompanyId", (companyId) => {
      vm.init();
    });
    vm.init();
  },
  // keep-alive组件激活时调用
  activated () {
    this.init();
  },
  // 数据更改导致的虚拟 DOM 重新渲染和打补丁，在这之后会调用该钩子
  updated () { },
  //当前路由改变
  beforeRouteUpdate () { },
  // Vue 实例销毁后调用
  destroyed () { },
  // 计算属性
  computed: {},
  // 数据监听
  watch: {},
  // 方法定义
  methods: {
    init () {
      api.measure
        .getMeasuresInfoByParam(
          this.$store.state.user.currentCompanyId,
          "cameraEzvizUrl",
          ""
        )
        .then((res) => {
          let apiArr = [];
          let videoData = [];
          for (let index = 0; index < res.data.length; index++) {
            const element = res.data[index];
            apiArr.push(api.measure.getMeasureProperty(element.id, ""));
            videoData.push(element);
          }
          Promise.all(apiArr).then((resArr) => {
            for (let j = 0; j < resArr.length; j++) {
              let data = resArr[j].data;
              const appKey = data.find((c) => c.name == "appKey");
              videoData[j].appKey = appKey ? appKey.value : "";
              const appSecret = data.find((c) => c.name == "appSecret");
              videoData[j].appSecret = appSecret ? appSecret.value : "";

              const cameraEzvizUrl = data.find(
                (c) => c.name == "cameraEzvizUrl"
              );
              videoData[j].cameraEzvizUrl = cameraEzvizUrl
                ? cameraEzvizUrl.value
                : "";
              const cameraType = data.find((c) => c.name == "CameraType");
              videoData[j].cameraType = cameraType ? cameraType.value : "";
              const cameraSerialNumber = data.find(
                (c) => c.name == "CameraSerialNumber"
              );
              videoData[j].cameraSerialNumber = cameraSerialNumber
                ? cameraSerialNumber.value
                : "";
              const channelNo = data.find((c) => c.name == "channelNo");
              videoData[j].channelNo = channelNo ? channelNo.value : "";
            }
            console.log(res.data)
            this.videoData = res.data;
          });
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.video-wrap {
  padding: 14px 0px;
  background: #fff;
  width: calc(100% - 28px);
  margin: 0px auto;
  margin-top: 14px;
  margin-bottom: 14px;
  display: flex;
  flex-wrap: wrap;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  min-height: calc(100% - 28px);
}
</style>